import * as React from 'react';
import { styled } from '@linaria/react';
import { Pause, Play } from 'lucide-react';

import ButtonPlayful from '@/components/ButtonPlayful';

function EraserWiggle() {
  const [isWiggling, setIsWiggling] = React.useState(true);
  return (
    <Wrapper>
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={128}
        height={128}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
      >
        <EraserGroup
          style={{
            animationPlayState: isWiggling ? 'running' : 'paused',
          }}
        >
          <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
          <path d="m5 11 9 9" />
        </EraserGroup>
        <path d="M22 21H3" />
      </Svg>
      <Button
        onClick={() => setIsWiggling(!isWiggling)}
        Icon={isWiggling ? Pause : Play}
        backgroundColor="var(--color-btn-bg)"
        highlightColor="var(--color-btn-highlight)"
      >
        {isWiggling ? 'Pause' : 'Play'}
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0rem;
  margin-bottom: 2rem;
`;

const Svg = styled.svg`
  overflow: visible;
`;

const EraserGroup = styled.g`
  animation: wiggle 1s cubic-bezier(0.66, 0, 0.34, 1) infinite
    alternate;
  will-change: transform;

  @keyframes wiggle {
    from {
      transform: translateX(-1px);
    }
    to {
      transform: translateX(5px);
    }
  }
`;

const Button = styled(ButtonPlayful)`
  width: 200px;

  --color-btn-bg: var(--color-gray-900);
  --color-btn-highlight: var(--color-gray-800);

  html[data-color-mode='dark'] & {
    --color-btn-bg: var(--color-gray-200);
    --color-btn-highlight: var(--color-gray-300);
  }

  /* For hover-capable devices, we want to hide the button by default and show on hover */
  @media (hover: hover) and (pointer: fine) {
    opacity: 0;
    transition: opacity 500ms;

    ${Wrapper}:hover &, &:focus-visible {
      opacity: 1;
      transition: opacity 150ms;
    }
  }
`;

export default EraserWiggle;
